import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthenticationService } from '../../authentication/authentication.service';
import { ICommunications } from '../../../models/ICommunications';
import { get } from 'aws-amplify/api';

@Injectable({
    providedIn: 'root'
})
export class CommunicationsService {
  stayData: any;
  constructor(private auth: AuthenticationService) {}
  getCommunicationstest(): Observable<ICommunications> {
    const op = get({
      apiName: 'portal',
      path: 'persons/communications/',
      // options: {} // optional
    });
    return from(
      op.response.then(async (r) => (await r.body.json()) as unknown as ICommunications)
    ).pipe(
      map((data: ICommunications) => data as ICommunications)
    );
  }
}
